<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import LePrivateSubscriptionBox from "@/components/subscription/LePrivateSubscriptionBox.vue";
import { useProductsStore } from "@/stores";
import type { PrivateSubscriptionBox } from "@/types";

const { t } = useI18n();
const productsStore = useProductsStore();

const subscription = ref<PrivateSubscriptionBox>();

const { dictionaries } = storeToRefs(productsStore);
const gyldendalProSubscription = productsStore.products.find((p) => p.id === "GYLDENDAL_PRO");

if (gyldendalProSubscription) {
  subscription.value = {
    label: {
      color: "warning",
      text: t("le-subscription-private-view.monthly-formatted-price", {
        price: gyldendalProSubscription.price,
        currency: gyldendalProSubscription.currency
      })
    },
    product: gyldendalProSubscription,
    usps: [
      t("le-subscription-private-view.subscription-usp.gyldendal-pro-dictionaries"),
      t("le-subscription-private-view.subscription-usp.unlimited-lookups"),
      t("le-subscription-private-view.subscription-usp.op5"),
      t("le-subscription-private-view.subscription-usp.mobile-app")
    ]
  };
}
</script>

<template>
  <LePrivateSubscriptionBox
    v-if="subscription"
    :key="subscription.product.id"
    :all-dictionaries="dictionaries"
    :subscription="subscription"
  />
</template>
